<div class="customer-user-management">
  <!-- 工具列 -->
  <div class="toolbar">
    <div class="row align-items-center">
      <div class="col-md-4">
        <div class="company-filter">
          <label for="companyFilter" class="form-label mb-2">選擇公司：</label>
          <select
            id="companyFilter"
            class="form-select"
            [(ngModel)]="selectedCompanyId"
            (change)="onCompanyChange()">
            <option value="">全部公司</option>
            <option *ngFor="let company of availableCompanies" [value]="company.companyid">
              {{ company.companyname }} ({{ company.userCount }})
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="search-box">
          <label for="searchInput" class="form-label mb-2">搜尋：</label>
          <input
            id="searchInput"
            type="text"
            class="form-control"
            placeholder="搜尋使用者名稱、Email或公司ID..."
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()">
        </div>
      </div>
      <div class="col-md-4 text-end">
        <div class="action-controls">
          <label class="form-label mb-2">&nbsp;</label>
          <button type="button" class="btn btn-primary d-block" (click)="addUser()">
            <i class="fas fa-user-plus me-2"></i>新增使用者
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 載入中 -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">載入中...</span>
      </div>
      <p class="mt-2">載入使用者資料中...</p>
    </div>
  </div>

  <!-- 使用者列表 -->
  <div *ngIf="!isLoading" class="users-list">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>使用者資訊</th>
            <th>公司ID</th>
            <th>權限摘要</th>
            <th>MFA狀態</th>
            <th>建立時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of getCurrentPageItems()">
            <td>
              <div class="user-info">
                <strong>{{ user.username }}</strong>
                <small class="text-muted d-block">{{ user.email }}</small>
              </div>
            </td>
            <td>
              <span class="badge bg-secondary">{{ user.companyid }}</span>
            </td>
            <td>
              <span class="permission-summary">{{ getUserPermissionSummary(user.modules) }}</span>
              <div class="permissions-detail mt-1">
                <small class="text-muted" *ngFor="let module of user.modules; let last = last">
                  {{ getAssistantTitle(module.assistantNo) }} ({{ getPermissionText(module.permission) }}){{ !last ? ', ' : '' }}
                </small>
              </div>
            </td>
            <td>
              <span class="badge" [class]="user.mfa?.enabled ? 'bg-success' : 'bg-secondary'">
                {{ user.mfa?.enabled ? '已啟用' : '未啟用' }}
              </span>
            </td>
            <td>{{ user.createdAt | date:'yyyy-MM-dd' }}</td>
            <td>
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="editUser(user)"
                  title="編輯">
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="deleteUser(user)"
                  title="刪除">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 無資料提示 -->
    <div *ngIf="filteredUsers.length === 0" class="no-data">
      <div class="text-center py-4">
        <i class="fas fa-users fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">沒有找到使用者資料</h5>
        <p class="text-muted">嘗試調整搜尋條件或新增第一個使用者。</p>
      </div>
    </div>

    <!-- 分頁 -->
    <div *ngIf="getTotalPages() > 1" class="pagination-container">
      <nav>
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="onPageChange(currentPage - 1)" href="#" (click)="$event.preventDefault()">上一頁</a>
          </li>
          <li *ngFor="let page of [].constructor(getTotalPages()); let i = index"
              class="page-item" [class.active]="currentPage === i + 1">
            <a class="page-link" (click)="onPageChange(i + 1)" href="#" (click)="$event.preventDefault()">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
            <a class="page-link" (click)="onPageChange(currentPage + 1)" href="#" (click)="$event.preventDefault()">下一頁</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- 編輯模態框 -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1" *ngIf="showModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-user me-2"></i>
          {{ isEditing ? '編輯使用者' : '新增使用者' }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="userForm" (ngSubmit)="saveUser()">

          <!-- 基本資訊 -->
          <div class="section-header">
            <h6><i class="fas fa-info-circle me-2"></i>基本資訊</h6>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">公司 *</label>
                <select class="form-select" formControlName="companyid" (change)="onModalCompanyChange()" [disabled]="isEditing">
                  <option value="">請選擇公司</option>
                  <option *ngFor="let company of availableCompanies" [value]="company.companyid">
                    {{ company.companyname }}
                  </option>
                </select>
                <small class="text-muted" *ngIf="isEditing">
                  <i class="fas fa-info-circle me-1"></i>
                  編輯模式下無法變更公司
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">使用者名稱 *</label>
                <input type="text" class="form-control" formControlName="username" placeholder="例: admin">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">密碼 {{ isEditing ? '(留空不更改)' : '*' }}</label>
                <input type="password" class="form-control" formControlName="password"
                       [placeholder]="isEditing ? '留空保留原密碼' : '至少6個字元'">
                <small class="text-muted" *ngIf="isEditing">
                  <i class="fas fa-info-circle me-1"></i>
                  編輯模式下如不更改密碼請留空
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Email *</label>
                <input type="email" class="form-control" formControlName="email" placeholder="例: user@company.com">
              </div>
            </div>
          </div>

          <!-- 安全設定 -->
          <!-- <div class="section-header">
            <h6><i class="fas fa-shield-alt me-2"></i>安全設定</h6>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" formControlName="mfaEnabled" id="mfaEnabled">
                  <label class="form-check-label" for="mfaEnabled">
                    啟用多重要素驗證 (MFA)
                  </label>
                </div>
              </div>
            </div>
          </div> -->

          <!-- 權限設定 -->
          <div class="section-header">
            <h6><i class="fas fa-key me-2"></i>權限設定</h6>
          </div>

          <div formArrayName="modules">
            <div *ngFor="let moduleGroup of modulesFormArray.controls; let i = index"
                 [formGroupName]="i" class="module-permission-item">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">助手模組 *</label>
                    <div class="position-relative">
                      <select class="form-select" formControlName="assistantNo" [disabled]="isLoadingAssistants || availableAssistants.length === 0">
                        <option value="" *ngIf="!isLoadingAssistants && availableAssistants.length === 0">請先選擇公司</option>
                        <option value="" *ngIf="isLoadingAssistants">載入中...</option>
                        <option value="" *ngIf="!isLoadingAssistants && availableAssistants.length > 0">請選擇助手</option>
                        <option *ngFor="let assistant of availableAssistants" [value]="assistant.assistantNo">
                          {{ assistant.title }}
                        </option>
                      </select>
                      <div *ngIf="isLoadingAssistants" class="position-absolute end-0 top-50 translate-middle-y me-3">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                          <span class="visually-hidden">載入中...</span>
                        </div>
                      </div>
                    </div>
                    <small class="text-muted" *ngIf="!isLoadingAssistants && availableAssistants.length === 0 && !assistantsLoadError">選擇公司後將自動載入該公司的助手列表</small>
                    <small class="text-danger" *ngIf="assistantsLoadError">
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      無法載入助手列表，請重新選擇公司或聯繫管理員
                      <button type="button" class="btn btn-link btn-sm p-0 ms-1" (click)="onModalCompanyChange()">
                        <i class="fas fa-refresh"></i> 重試
                      </button>
                    </small>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">權限等級 *</label>
                    <select class="form-select" formControlName="permission">
                      <option value="">請選擇權限等級</option>
                      <option *ngFor="let permission of availablePermissions" [value]="permission.value">
                        {{ permission.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="mb-3">
                    <label class="form-label">&nbsp;</label>
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm d-block"
                      (click)="removeModuleFormGroup(i)"
                      [disabled]="modulesFormArray.length === 1"
                      title="刪除權限">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end" *ngIf="!hasAllAssistantSelected()">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addModuleFormGroup()">
              <i class="fas fa-plus me-2"></i>新增權限
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">取消</button>
        <button type="button" class="btn btn-primary" (click)="saveUser()" [disabled]="!userForm.valid || modulesFormArray.length === 0">
          <i class="fas fa-save me-2"></i>{{ isEditing ? '更新' : '新增' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 模態框背景 -->
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
